module.exports = __webpack_public_path__ + "mainassets/img/form_2.8e2808c5.svg";